import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

export default class RangeSlider extends Component {
    static get propTypes() {
        return {
            min: PropTypes.number,
            max: PropTypes.number,
            step: PropTypes.number,
            readOnly: PropTypes.bool,
            value: PropTypes.number,
            handle: PropTypes.object,
            triggerInputOnMount: PropTypes.boolean,
            options: PropTypes.object,
            inputProps: PropTypes.object,
            onInput: PropTypes.func,
            onChange: PropTypes.func,
        };
    }

    componentDidMount() {
        if (!this.root || !this.input) {
            return;
        }

        this.$root = $(this.root);
        this.$slider = $(this.input);
        this.$slider.rangeslider({
            polyfill: false,
            ...this.props.options
        });

        // Update the slider every 100ms until it has a non-zero size (rangeslider sucks).
        const plugin = this.$slider.data('plugin_rangeslider');
        const layoutCheckTimer = setInterval(() => {
            plugin.update();
            if (plugin.rangeDimension == 0) {
                return;
            }
            clearInterval(layoutCheckTimer);
            if (this.props.value != null) {
                this.$slider.val(this.props.value).rangeslider('update', true);
            }
            if (this.props.handle) {
                this.$root.find('.rangeslider__handle').append(this.props.handle);
            }
            this.$slider
                .on('input', this.props.onInput)
                .on('change', this.props.onChange);
            if (this.props.triggerInputOnMount) {
                this.$slider.trigger('input');
            }
        }, 100);
    }

    componentDidUpdate() {
        this.setValue(this.props.value);
    }

    componentWillUnmount() {
        this.$slider.rangeslider('destroy');
    }

    setValue(value) {
        if (!this.$slider) {
            return;
        }

        this.$slider
            .off('input')
            .off('change')
            .val(value)
            .rangeslider('update', true)
            .on('input', this.props.onInput)
            .on('change', this.props.onChange);
    }

    render() {
        return (
            // DO NOT remove the wrapper <div>!
            // More info: https://reactjs.org/docs/integrating-with-other-libraries.html
            <div className="rangeslider-wrapper" ref={node => this.root = node} style={{flex: 1}}>
                <input
                    ref={node => this.input = node}
                    type="range"
                    min={this.props.min}
                    max={this.props.max}
                    step={this.props.step}
                    readOnly={this.props.readOnly}
                    value={this.props.value}
                    {...this.props.inputProps}/>
            </div>
        );
    }
}
